var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "微信小程序版本管理",
            visible: _vm.dialogVisible,
            width: "1120px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _vm.prepareInfo && !_vm.prepareInfo.runnerReady
            ? _c("el-alert", {
                staticClass: "page-alert",
                attrs: {
                  title:
                    "Build Runner尚未接入，上传任务会停留在等待Runner状态；真实构建上传代码已保留TODO。",
                  type: "warning",
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.prepareInfo && !_vm.prepareInfo.wechatApiReady
            ? _c("el-alert", {
                staticClass: "page-alert",
                attrs: {
                  title: _vm.wechatApiReadyTip,
                  type: "warning",
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.prepareInfo
            ? _c("div", { staticClass: "info-grid app-summary" }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("小程序名称"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.prepareInfo.appName || "-")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [_vm._v("AppID")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.prepareInfo.appId || "-")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("最近上传版本"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.prepareInfo.lastUploadedVersion || "-")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("微信线上版本"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "info-value" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.prepareInfo.onlineVersion || "-") +
                          "\n          "
                      ),
                      _vm.prepareInfo.onlineVersionTip
                        ? _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.prepareInfo.onlineVersionTip,
                                placement: "top",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("微信体验版"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "info-value" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.prepareInfo.experienceVersion || "-") +
                          "\n          "
                      ),
                      _vm.prepareInfo.experienceVersionDesc
                        ? _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.prepareInfo.experienceVersionDesc,
                                placement: "top",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item summary-sync-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("微信状态"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "info-value" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["admin:miniapp:release"],
                              expression: "['admin:miniapp:release']",
                            },
                          ],
                          attrs: {
                            type: "primary",
                            plain: "",
                            size: "mini",
                            icon: "el-icon-refresh",
                            loading: _vm.wechatSyncLoading,
                          },
                          on: { click: _vm.syncWechatVersion },
                        },
                        [_vm._v("同步微信状态")]
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "上传管理", name: "upload" } },
                [
                  _c(
                    "el-card",
                    { staticClass: "section-card", attrs: { shadow: "never" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "section-title",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_vm._v("创建上传任务")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          ref: "uploadForm",
                          staticClass: "upload-form",
                          attrs: {
                            model: _vm.uploadForm,
                            rules: _vm.uploadRules,
                            "label-width": "125px",
                          },
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Git分支",
                                        prop: "branchName",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            loading: _vm.branchLoading,
                                            filterable: "",
                                            "allow-create": "",
                                            "default-first-option": "",
                                            placeholder: "请选择或输入远程分支",
                                          },
                                          model: {
                                            value: _vm.uploadForm.branchName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.uploadForm,
                                                "branchName",
                                                $$v
                                              )
                                            },
                                            expression: "uploadForm.branchName",
                                          },
                                        },
                                        _vm._l(
                                          _vm.branchOptions,
                                          function (branch) {
                                            return _c("el-option", {
                                              key: branch,
                                              attrs: {
                                                label: branch,
                                                value: branch,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.branchLoadError
                                        ? _c(
                                            "div",
                                            { staticClass: "form-error-tip" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(_vm.branchLoadError) +
                                                  "，已保留默认分支和手动输入能力。\n                  "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-tip branch-tip",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    已加载" +
                                                  _vm._s(
                                                    _vm.remoteBranchOptions
                                                      .length
                                                  ) +
                                                  "个远程分支\n                  "
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "接口环境",
                                        prop: "environmentCode",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          on: {
                                            change:
                                              _vm.handleUploadEnvironmentChange,
                                          },
                                          model: {
                                            value:
                                              _vm.uploadForm.environmentCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.uploadForm,
                                                "environmentCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "uploadForm.environmentCode",
                                          },
                                        },
                                        _vm._l(
                                          _vm.environmentOptions,
                                          function (item) {
                                            return _c(
                                              "el-option",
                                              {
                                                key: item.code,
                                                attrs: {
                                                  label: item.name,
                                                  value: item.code,
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(item.name)),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "environment-domain",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.domain ||
                                                          "用户输入"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "uniAppId" } },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [
                                          _vm._v(
                                            "\n                    UniAppID\n                    "
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content:
                                                  "请勿随意改动，否则将无法上传",
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-question",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: "64",
                                          placeholder: "例如：__UNI__6610B0B",
                                        },
                                        model: {
                                          value: _vm.uploadForm.uniAppId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.uploadForm,
                                              "uniAppId",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "uploadForm.uniAppId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label:
                                          _vm.uploadForm.environmentCode ===
                                          "CUSTOM"
                                            ? "自定义域名"
                                            : "目标域名",
                                        prop:
                                          _vm.uploadForm.environmentCode ===
                                          "CUSTOM"
                                            ? "customDomain"
                                            : "",
                                      },
                                    },
                                    [
                                      _vm.uploadForm.environmentCode ===
                                      "CUSTOM"
                                        ? _c("el-input", {
                                            attrs: {
                                              maxlength: "255",
                                              placeholder:
                                                "https://example.com",
                                            },
                                            model: {
                                              value:
                                                _vm.uploadForm.customDomain,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.uploadForm,
                                                  "customDomain",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "uploadForm.customDomain",
                                            },
                                          })
                                        : _c("el-input", {
                                            attrs: {
                                              value: _vm.targetDomainPreview,
                                              readonly: "",
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "CI机器人",
                                        prop: "robotNo",
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          min:
                                            _vm.uploadForm.environmentCode ===
                                            "CUSTOM"
                                              ? 5
                                              : _vm.uploadForm.robotNo,
                                          max:
                                            _vm.uploadForm.environmentCode ===
                                            "CUSTOM"
                                              ? 30
                                              : _vm.uploadForm.robotNo,
                                          disabled:
                                            _vm.uploadForm.environmentCode !==
                                            "CUSTOM",
                                          "controls-position": "right",
                                        },
                                        model: {
                                          value: _vm.uploadForm.robotNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.uploadForm,
                                              "robotNo",
                                              $$v
                                            )
                                          },
                                          expression: "uploadForm.robotNo",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "inline-tip" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.uploadForm
                                                  .environmentCode === "CUSTOM"
                                                  ? "自定义环境可选5-30"
                                                  : "由接口环境固定"
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "版本号",
                                        prop: "versionNo",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: "64",
                                          "show-word-limit": "",
                                        },
                                        model: {
                                          value: _vm.uploadForm.versionNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.uploadForm,
                                              "versionNo",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "uploadForm.versionNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "更新体验版",
                                        prop: "trialRequested",
                                      },
                                    },
                                    [
                                      _c("el-switch", {
                                        model: {
                                          value: _vm.uploadForm.trialRequested,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.uploadForm,
                                              "trialRequested",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "uploadForm.trialRequested",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "版本描述", prop: "versionDesc" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  maxlength: "200",
                                  "show-word-limit": "",
                                  placeholder: "请填写本次版本的主要修改内容",
                                },
                                model: {
                                  value: _vm.uploadForm.versionDesc,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.uploadForm,
                                      "versionDesc",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "uploadForm.versionDesc",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: ["admin:miniapp:release:upload"],
                                      expression:
                                        "['admin:miniapp:release:upload']",
                                    },
                                  ],
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.createLoading,
                                  },
                                  on: { click: _vm.createAndSubmitUpload },
                                },
                                [_vm._v("创建并提交上传")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                { on: { click: _vm.resetUploadForm } },
                                [_vm._v("重置")]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "form-tip" }, [
                                _vm._v(
                                  "Runner会在独立目录中改写config/app.js和manifest.json，不会将修改提交到Git。"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-card",
                    { staticClass: "section-card", attrs: { shadow: "never" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "section-title",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_vm._v("上传版本记录")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.versionLoading,
                              expression: "versionLoading",
                            },
                          ],
                          attrs: {
                            data: _vm.versionList,
                            border: "",
                            size: "mini",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "versionNo",
                              label: "版本号",
                              "min-width": "90",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "环境", width: "90" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.getEnvironmentTagType(
                                            scope.row.environmentCode
                                          ),
                                          size: "mini",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(scope.row.environmentCode) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "通道", width: "80" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getUploadChannelLabel(
                                          scope.row.uploadChannel
                                        )
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "targetDomain",
                              label: "目标域名",
                              "min-width": "200",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "branchName",
                              label: "分支",
                              "min-width": "150",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "versionDesc",
                              label: "上传版本描述",
                              "min-width": "220",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(scope.row.versionDesc || "-")
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "uniAppId",
                              label: "UniAppID",
                              "min-width": "135",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "上传状态", width: "105" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.getUploadStatus(
                                            scope.row.uploadStatus
                                          ).type,
                                          size: "mini",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.getUploadStatus(
                                                scope.row.uploadStatus
                                              ).label
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "体验版", width: "110" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          disabled:
                                            !scope.row.trialErrorMessage,
                                          content: scope.row.trialErrorMessage,
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type: _vm.getTrialStatus(
                                                    scope.row.trialStatus
                                                  ).type,
                                                  size: "mini",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.getTrialStatus(
                                                        scope.row.trialStatus
                                                      ).label
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "operatorName",
                              label: "操作人",
                              width: "90",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "250",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showVersionDetail(
                                              scope.row.id
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("详情")]
                                    ),
                                    _vm._v(" "),
                                    _vm.canShowTrialQrcode(scope.row)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:miniapp:release",
                                                ],
                                                expression:
                                                  "['admin:miniapp:release']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showTrialQrcode(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("体验版二维码")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.canSubmitUpload(scope.row.uploadStatus)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:miniapp:release:upload",
                                                ],
                                                expression:
                                                  "['admin:miniapp:release:upload']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                              loading:
                                                _vm.actionId === scope.row.id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.submitUpload(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("重试上传")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.canCancelUpload(scope.row.uploadStatus)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:miniapp:release:upload",
                                                ],
                                                expression:
                                                  "['admin:miniapp:release:upload']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                              loading:
                                                _vm.actionId === scope.row.id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.cancelUploadTask(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("中止")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.canRequestTrial(scope.row)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:miniapp:release:upload",
                                                ],
                                                expression:
                                                  "['admin:miniapp:release:upload']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                              loading:
                                                _vm.actionId === scope.row.id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.requestTrial(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("设为体验版")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-pagination", {
                        staticClass: "table-pagination",
                        attrs: {
                          "current-page": _vm.versionPage.page,
                          "page-size": _vm.versionPage.limit,
                          layout: "total, prev, pager, next",
                          total: _vm.versionTotal,
                        },
                        on: { "current-change": _vm.handleVersionPageChange },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "审核管理", name: "audit" } },
                [
                  _c("el-alert", {
                    staticClass: "page-alert",
                    attrs: {
                      title:
                        "只有PROD正式域名版本上传成功、校验通过且已确认为当前体验版后，才能提交微信审核。",
                      type: "warning",
                      closable: false,
                      "show-icon": "",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-card",
                    { staticClass: "section-card", attrs: { shadow: "never" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "section-title",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_vm._v("PROD上传版本")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.prodLoading,
                              expression: "prodLoading",
                            },
                          ],
                          ref: "prodVersionTable",
                          attrs: {
                            data: _vm.prodVersionList,
                            border: "",
                            size: "mini",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "versionNo",
                              label: "版本号",
                              width: "100",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "branchName",
                              label: "分支",
                              "min-width": "150",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "versionDesc",
                              label: "上传版本描述",
                              "min-width": "220",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(scope.row.versionDesc || "-")
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "commitSha",
                              label: "Commit",
                              "min-width": "120",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "上传状态", width: "105" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getUploadStatus(
                                          scope.row.uploadStatus
                                        ).label
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "最近审核", width: "110" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getAuditStatus(
                                            scope.row.latestAuditStatus
                                          ).label
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "审核条件", "min-width": "210" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.auditEligible
                                      ? _c(
                                          "span",
                                          { staticClass: "success-text" },
                                          [_vm._v("可以提交审核")]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "muted-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.auditDisabledReason ||
                                                  "-"
                                              )
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "130",
                              "class-name": "audit-operation-cell",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.auditEligible
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:miniapp:release:audit",
                                                ],
                                                expression:
                                                  "['admin:miniapp:release:audit']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                              loading:
                                                _vm.actionId === scope.row.id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openAuditDialog(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("提交审核")]
                                        )
                                      : _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showVersionDetail(
                                                  scope.row.id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("查看")]
                                        ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-pagination", {
                        staticClass: "table-pagination",
                        attrs: {
                          "current-page": _vm.prodPage.page,
                          "page-size": _vm.prodPage.limit,
                          layout: "total, prev, pager, next",
                          total: _vm.prodTotal,
                        },
                        on: { "current-change": _vm.handleProdPageChange },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-card",
                    { staticClass: "section-card", attrs: { shadow: "never" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "section-title",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_vm._v("审核记录")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "audit-record-tip" }, [
                        _vm._v(
                          "列表状态由微信回调更新；查看详情会实时查询微信，但不修改本地记录。审核驳回、提交失败或已撤回可重新提审，审核中或延后可撤回。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.auditLoading,
                              expression: "auditLoading",
                            },
                          ],
                          ref: "auditRecordTable",
                          attrs: {
                            data: _vm.auditList,
                            border: "",
                            size: "mini",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "versionNo",
                              label: "版本号",
                              width: "100",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "branchName",
                              label: "分支",
                              "min-width": "150",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "versionDesc",
                              label: "提审版本描述",
                              "min-width": "220",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(scope.row.versionDesc || "-")
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "wechatAuditId",
                              label: "微信审核单",
                              "min-width": "120",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "审核状态", width: "110" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.getAuditStatus(
                                            scope.row.auditStatus
                                          ).type,
                                          size: "mini",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.getAuditStatus(
                                                scope.row.auditStatus
                                              ).label
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "rejectReason",
                              label: "驳回原因",
                              "min-width": "220",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "errorMessage",
                              label: "接口错误",
                              "min-width": "180",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "operatorName",
                              label: "操作人",
                              width: "90",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "创建时间", width: "150" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDateTime(scope.row.createTime)
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "290",
                              "class-name": "audit-operation-cell",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.canResubmitAudit(scope.row)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:miniapp:release:audit",
                                                ],
                                                expression:
                                                  "['admin:miniapp:release:audit']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                              loading:
                                                _vm.actionId === scope.row.id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.resubmitAudit(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("重新提审")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "has-permi",
                                            rawName: "v-has-permi",
                                            value: ["admin:miniapp:release"],
                                            expression:
                                              "['admin:miniapp:release']",
                                          },
                                        ],
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.viewAuditDetail(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("查看详情")]
                                    ),
                                    _vm._v(" "),
                                    _vm.canOperateAudit(scope.row)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:miniapp:release:audit",
                                                ],
                                                expression:
                                                  "['admin:miniapp:release:audit']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.speedupAudit(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("加急")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.canOperateAudit(scope.row)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:miniapp:release:audit",
                                                ],
                                                expression:
                                                  "['admin:miniapp:release:audit']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.undoAudit(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("撤回审核")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-pagination", {
                        staticClass: "table-pagination",
                        attrs: {
                          "current-page": _vm.auditPage.page,
                          "page-size": _vm.auditPage.limit,
                          layout: "total, prev, pager, next",
                          total: _vm.auditTotal,
                        },
                        on: { "current-change": _vm.handleAuditPageChange },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "发布管理", name: "publish" } },
                [
                  _c("el-alert", {
                    staticClass: "page-alert",
                    attrs: {
                      title:
                        "只有微信审核通过的版本才能发布，发布操作需要二次确认。",
                      type: "info",
                      closable: false,
                      "show-icon": "",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-card",
                    { staticClass: "section-card", attrs: { shadow: "never" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "section-title section-title-between",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [_vm._v("审核通过版本")]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: ["admin:miniapp:release:publish"],
                                  expression:
                                    "['admin:miniapp:release:publish']",
                                },
                              ],
                              attrs: {
                                type: "danger",
                                plain: "",
                                size: "mini",
                              },
                              on: { click: _vm.rollbackRelease },
                            },
                            [_vm._v("回退线上版本")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.passedLoading,
                              expression: "passedLoading",
                            },
                          ],
                          attrs: {
                            data: _vm.passedAuditList,
                            border: "",
                            size: "mini",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "versionNo",
                              label: "版本号",
                              width: "100",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "branchName",
                              label: "分支",
                              "min-width": "160",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "versionDesc",
                              label: "提审版本描述",
                              "min-width": "220",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(scope.row.versionDesc || "-")
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "wechatAuditId",
                              label: "微信审核单",
                              "min-width": "120",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "发布状态", width: "120" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getPublishStatus(
                                            scope.row.latestPublishStatus
                                          ).label
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "审核完成时间", width: "150" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDateTime(scope.row.finishTime)
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作", width: "150" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.canPublish(scope.row)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:miniapp:release:publish",
                                                ],
                                                expression:
                                                  "['admin:miniapp:release:publish']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                              loading:
                                                _vm.actionId === scope.row.id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.publishVersion(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("正式发布")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-card",
                    { staticClass: "section-card", attrs: { shadow: "never" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "section-title",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_vm._v("发布记录")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.publishLoading,
                              expression: "publishLoading",
                            },
                          ],
                          attrs: {
                            data: _vm.publishList,
                            border: "",
                            size: "mini",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "versionNo",
                              label: "版本号",
                              width: "100",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "versionDesc",
                              label: "提审版本描述",
                              "min-width": "220",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(scope.row.versionDesc || "-")
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "auditId",
                              label: "审核记录ID",
                              width: "110",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "发布状态", width: "120" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.getPublishStatus(
                                            scope.row.publishStatus
                                          ).type,
                                          size: "mini",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.getPublishStatus(
                                                scope.row.publishStatus
                                              ).label
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "errorMessage",
                              label: "失败原因",
                              "min-width": "220",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "operatorName",
                              label: "操作人",
                              width: "90",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "发布时间", width: "150" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDateTime(
                                          scope.row.releaseTime ||
                                            scope.row.createTime
                                        )
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-pagination", {
                        staticClass: "table-pagination",
                        attrs: {
                          "current-page": _vm.publishPage.page,
                          "page-size": _vm.publishPage.limit,
                          layout: "total, prev, pager, next",
                          total: _vm.publishTotal,
                        },
                        on: { "current-change": _vm.handlePublishPageChange },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.auditSourceRecord ? "重新提交微信审核" : "提交微信审核",
            visible: _vm.auditDialogVisible,
            width: "860px",
            top: "5vh",
            "custom-class": "mini-program-audit-dialog",
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.closeAuditDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.auditDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.auditPrepareLoading,
                  expression: "auditPrepareLoading",
                },
              ],
            },
            [
              _vm.auditSourceRecord
                ? _c("el-alert", {
                    staticClass: "page-alert audit-source-tip",
                    attrs: {
                      title:
                        "基于审核记录 #" +
                        _vm.auditSourceRecord.id +
                        " 重新提审，提交成功后新增审核记录，原记录保留。",
                      description: _vm.auditSourceTip,
                      type: "warning",
                      closable: false,
                      "show-icon": "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.auditVersion
                ? _c("el-alert", {
                    staticClass: "page-alert",
                    attrs: {
                      title:
                        "将 PROD 版本 " +
                        _vm.auditVersion.versionNo +
                        " 提交微信审核，请确认页面和类目与实际功能一致。",
                      type: "warning",
                      closable: false,
                      "show-icon": "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  key: _vm.auditFormSeq,
                  attrs: {
                    "label-width": "110px",
                    disabled: _vm.auditSubmitLoading,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "版本描述" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          maxlength: "200",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.auditForm.versionDesc,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.auditForm,
                              "versionDesc",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "auditForm.versionDesc",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "审核页面" } },
                    [
                      _vm._l(_vm.auditForm.itemList, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "audit-item" },
                          [
                            _c(
                              "div",
                              { staticClass: "audit-item-header" },
                              [
                                _c("span", [
                                  _vm._v("页面 " + _vm._s(index + 1)),
                                ]),
                                _vm._v(" "),
                                _vm.auditForm.itemList.length > 1
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "danger-text",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeAuditItem(index)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 12 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          filterable: "",
                                          placeholder: "选择体验版页面路径",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.handleAuditItemPageChange(
                                              item
                                            )
                                          },
                                        },
                                        model: {
                                          value: item.address,
                                          callback: function ($$v) {
                                            _vm.$set(item, "address", $$v)
                                          },
                                          expression: "item.address",
                                        },
                                      },
                                      _vm._l(
                                        _vm.auditPageOptions,
                                        function (page) {
                                          return _c("el-option", {
                                            key: page,
                                            attrs: { label: page, value: page },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: "选择已设置类目",
                                        },
                                        model: {
                                          value: item.categoryIndex,
                                          callback: function ($$v) {
                                            _vm.$set(item, "categoryIndex", $$v)
                                          },
                                          expression: "item.categoryIndex",
                                        },
                                      },
                                      _vm._l(
                                        _vm.auditCategoryOptions,
                                        function (category, categoryIndex) {
                                          return _c("el-option", {
                                            key: _vm.categoryKey(
                                              category,
                                              categoryIndex
                                            ),
                                            attrs: {
                                              label:
                                                _vm.categoryLabel(category),
                                              value: categoryIndex,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "audit-item-row",
                                attrs: { gutter: 12 },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        maxlength: "32",
                                        placeholder: "页面标题（必填）",
                                      },
                                      model: {
                                        value: item.title,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "title",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "item.title",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        maxlength: "32",
                                        placeholder: "页面标签（选填）",
                                      },
                                      model: {
                                        value: item.tag,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "tag",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "item.tag",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "text",
                            icon: "el-icon-plus",
                            disabled: _vm.auditForm.itemList.length >= 5,
                          },
                          on: { click: _vm.addAuditItem },
                        },
                        [_vm._v("添加审核页面")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "audit-field-tip" }, [
                        _vm._v(
                          "最多5个页面。首页路径自动填写“首页”，其他页面请填写实际页面名称，可手动修改。"
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "图片预览" } },
                    [
                      _c("audit-media-upload", {
                        attrs: {
                          "company-app-id": _vm.companyApp.id,
                          purpose: "preview_image",
                          limit: 10,
                          disabled:
                            _vm.auditSubmitLoading || _vm.auditPrepareLoading,
                        },
                        on: {
                          "busy-change": function ($event) {
                            return _vm.$set(
                              _vm.auditMediaBusy,
                              "previewImage",
                              $event
                            )
                          },
                        },
                        model: {
                          value: _vm.auditForm.previewImageIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.auditForm, "previewImageIds", $$v)
                          },
                          expression: "auditForm.previewImageIds",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "视频预览" } },
                    [
                      _c("audit-media-upload", {
                        attrs: {
                          "company-app-id": _vm.companyApp.id,
                          purpose: "preview_video",
                          limit: 1,
                          disabled:
                            _vm.auditSubmitLoading || _vm.auditPrepareLoading,
                        },
                        on: {
                          "busy-change": function ($event) {
                            return _vm.$set(
                              _vm.auditMediaBusy,
                              "previewVideo",
                              $event
                            )
                          },
                        },
                        model: {
                          value: _vm.auditForm.previewVideoIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.auditForm, "previewVideoIds", $$v)
                          },
                          expression: "auditForm.previewVideoIds",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单中心Path" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "128",
                          placeholder: "选填，例如pages/users/orderList/index",
                        },
                        model: {
                          value: _vm.auditForm.orderPath,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.auditForm,
                              "orderPath",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "auditForm.orderPath",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "audit-field-tip" }, [
                        _vm._v(
                          "填写本次代码中的订单页面路径，不要包含域名、开头的 / 或查询参数。"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "隐私接口声明" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.auditForm.privacyApiNotUse,
                            callback: function ($$v) {
                              _vm.$set(_vm.auditForm, "privacyApiNotUse", $$v)
                            },
                            expression: "auditForm.privacyApiNotUse",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "不额外声明（默认）", value: "" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: "不使用代码检测出但未配置的隐私接口",
                              value: true,
                            },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: "使用相关隐私接口（请先完善隐私保护指引）",
                              value: false,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "audit-field-tip" }, [
                        _vm._v(
                          "此声明不等于“不采集用户隐私”。隐私保护指引请到服务商的隐私保护指引管理中配置。"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "审核加急" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.auditForm.speedupRequested,
                            callback: function ($$v) {
                              _vm.$set(_vm.auditForm, "speedupRequested", $$v)
                            },
                            expression: "auditForm.speedupRequested",
                          },
                        },
                        [_vm._v("提交审核成功后申请加急")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "audit-field-tip" }, [
                        _vm._v(
                          "微信会校验服务商加急额度；加急失败不会撤回已提交的审核，也可稍后在审核记录中重试。"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "驳回反馈" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          maxlength: "200",
                          "show-word-limit": "",
                          placeholder:
                            "选填，上个版本被驳回后，说明本次修改或补充解释",
                        },
                        model: {
                          value: _vm.auditForm.feedbackInfo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.auditForm,
                              "feedbackInfo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "auditForm.feedbackInfo",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "audit-field-tip" }, [
                        _vm._v(
                          "反馈文字和反馈图片用于驳回后的再次提审，不替代上面的预览截图。"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "反馈图片" } },
                    [
                      _c("audit-media-upload", {
                        attrs: {
                          "company-app-id": _vm.companyApp.id,
                          purpose: "feedback_image",
                          limit: 5,
                          disabled:
                            _vm.auditSubmitLoading || _vm.auditPrepareLoading,
                        },
                        on: {
                          "busy-change": function ($event) {
                            return _vm.$set(
                              _vm.auditMediaBusy,
                              "feedbackImage",
                              $event
                            )
                          },
                        },
                        model: {
                          value: _vm.auditForm.feedbackImageIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.auditForm, "feedbackImageIds", $$v)
                          },
                          expression: "auditForm.feedbackImageIds",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.auditSubmitLoading || _vm.auditMediaUploading,
                  },
                  on: { click: _vm.closeAuditDialog },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.auditSubmitLoading,
                    disabled:
                      _vm.auditPrepareLoading || _vm.auditMediaUploading,
                  },
                  on: { click: _vm.confirmSubmitAudit },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.auditMediaUploading ? "素材上传中" : "确认提交审核"
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传版本详情",
            visible: _vm.detailVisible,
            width: "780px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _vm.versionDetail
            ? _c(
                "el-steps",
                {
                  staticClass: "task-steps",
                  attrs: {
                    active: _vm.getUploadStep(
                      _vm.versionDetail.currentStep ||
                        _vm.versionDetail.uploadStatus
                    ),
                    "finish-status": "success",
                    "align-center": "",
                  },
                },
                [
                  _c("el-step", { attrs: { title: "创建任务" } }),
                  _vm._v(" "),
                  _c("el-step", { attrs: { title: "拉取代码" } }),
                  _vm._v(" "),
                  _c("el-step", { attrs: { title: "环境校验" } }),
                  _vm._v(" "),
                  _c("el-step", { attrs: { title: "HBuilderX编译" } }),
                  _vm._v(" "),
                  _c("el-step", { attrs: { title: "微信上传" } }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.versionDetail
            ? _c("div", { staticClass: "info-grid detail-grid" }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [_vm._v("版本号")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.versionDetail.versionNo || "-")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [_vm._v("环境")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.versionDetail.environmentCode || "-")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item info-item-full" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("上传通道"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "info-value" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.getUploadChannelLabel(
                              _vm.versionDetail.uploadChannel
                            )
                          ) +
                          "\n          "
                      ),
                      _vm.getUploadChannelTip(_vm.versionDetail.uploadChannel)
                        ? _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.getUploadChannelTip(
                                  _vm.versionDetail.uploadChannel
                                ),
                                placement: "top",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item info-item-full" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("目标域名"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.versionDetail.targetDomain || "-")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [_vm._v("分支")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.versionDetail.branchName || "-")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [_vm._v("Commit")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.versionDetail.commitSha || "-")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item info-item-full" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("UniAppID"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.versionDetail.uniAppId || "-")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("域名校验"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.getCheckStatus(_vm.versionDetail.domainCheckStatus)
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("AppID校验"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.getCheckStatus(_vm.versionDetail.appIdCheckStatus)
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("微信体验版版本"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(
                      _vm._s(_vm.versionDetail.wechatExperienceVersion || "-")
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("微信线上版本"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(
                      _vm._s(_vm.versionDetail.wechatReleaseVersion || "-")
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.versionDetail.wechatSyncError
                  ? _c("div", { staticClass: "info-item info-item-full" }, [
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v("微信同步失败原因"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "info-value" }, [
                        _vm._v(_vm._s(_vm.versionDetail.wechatSyncError)),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "info-item info-item-full" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("失败原因"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.versionDetail.uploadErrorMessage || "-")),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "log-title" }, [_vm._v("执行日志")]),
          _vm._v(" "),
          _c("pre", { staticClass: "build-log" }, [
            _vm._v(
              _vm._s(
                (_vm.versionDetail && _vm.versionDetail.buildLog) || "暂无日志"
              )
            ),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "体验版二维码",
            visible: _vm.qrcodeVisible,
            width: "420px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrcodeVisible = $event
            },
            close: _vm.handleTrialQrcodeClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "qrcode-toolbar" },
            [
              _c("el-input", {
                staticClass: "qrcode-path-input",
                attrs: {
                  size: "mini",
                  clearable: "",
                  placeholder: "pages/index/index",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.loadTrialQrcode($event)
                  },
                },
                model: {
                  value: _vm.qrcodePath,
                  callback: function ($$v) {
                    _vm.qrcodePath = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "qrcodePath",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: "primary",
                    loading: _vm.qrcodeLoading,
                  },
                  on: { click: _vm.loadTrialQrcode },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.qrcodeLoading,
                  expression: "qrcodeLoading",
                },
              ],
              staticClass: "qrcode-body",
            },
            [
              _vm.qrcodeUrl
                ? _c("img", {
                    staticClass: "qrcode-image",
                    attrs: { src: _vm.qrcodeUrl, alt: "体验版二维码" },
                    on: { error: _vm.handleTrialQrcodeImageError },
                  })
                : _vm.qrcodeError
                ? _c("div", { staticClass: "qrcode-error" }, [
                    _vm._v(_vm._s(_vm.qrcodeError)),
                  ])
                : _c("div", { staticClass: "qrcode-empty" }, [
                    _vm._v("暂无二维码"),
                  ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "qrcode-version" }, [
            _vm._v(
              "当前版本号：" +
                _vm._s(
                  (_vm.qrcodeVersion && _vm.qrcodeVersion.versionNo) || "-"
                )
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("audit-detail", { ref: "auditDetail" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }